import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_LOAD_MORE, DEFAULT_PAGE_NUMBER } from '../../../../constants';
import { clientRequirementsRoute } from '../route';

import { clientAndIdentityFilterFormSchema } from './components/clientAndIdentityFilterFormSchema';

const clientAndIdentityValidateSearchSchema = z.object({
	openedRequirement: z.string().optional(),
	filter: clientAndIdentityFilterFormSchema.catch({
		operationType: undefined,
		operationStatuses: [],
	}),
	pageNumber: z.number().default(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().default(DEFAULT_LOAD_MORE),
});

export const clientAndIdentityPageRoute = createRoute({
	path: '/client-and-identity',
	getParentRoute: () => clientRequirementsRoute,
	component: lazyRouteComponent(
		() => import('./ClientAndIdentityPage'),
		'ClientAndIdentityPage',
	),
	validateSearch: clientAndIdentityValidateSearchSchema,
});
